import { api } from '@/lib/api'

export interface VoorraadPartij {
  id: number
  organisation_id: number
  partijnummer: string
  productomschrijving?: string | null
  aantal: number
  eenheid?: string | null
  waarderingsprijs_per_eenheid: number
  totale_waarde: number
  inslagdatum?: string | null
  tht_datum?: string | null
  resterende_dagen?: number | null
  opslaglocatie?: string | null
  voorraadstatus?: string | null
  orderstatus?: string | null
  ordernummer?: string | null
  crediteur?: string | null
  crediteurnummer?: string | null
  inkoopfactuurnr?: string | null
  opmerkingen?: string | null
}

export interface VoorraadPayload {
  partijnummer: string
  productomschrijving?: string | null
  aantal?: number
  eenheid?: string | null
  waarderingsprijs_per_eenheid?: number
  totale_waarde?: number | null
  inslagdatum?: string | null
  tht_datum?: string | null
  opslaglocatie?: string | null
  voorraadstatus?: string | null
  orderstatus?: string | null
  ordernummer?: string | null
  crediteur?: string | null
  crediteurnummer?: string | null
  inkoopfactuurnr: string
  opmerkingen?: string | null
}

export const fetchVoorraad = (orgId: number, params?: { zoek?: string; voorraadstatus?: string; orderstatus?: string }) =>
  api.get<VoorraadPartij[]>(`/api/voorraad/${orgId}`, { params }).then(r => r.data)

export const aanmakenPartij = (orgId: number, data: VoorraadPayload) =>
  api.post<VoorraadPartij>(`/api/voorraad/${orgId}`, data).then(r => r.data)

export const bijwerkenPartij = (orgId: number, id: number, data: Partial<VoorraadPayload>) =>
  api.put<VoorraadPartij>(`/api/voorraad/${orgId}/${id}`, data).then(r => r.data)

export const verwijderenPartij = (orgId: number, id: number) =>
  api.delete(`/api/voorraad/${orgId}/${id}`)
